export const initialAbility = [
  {
    action: 'manage',
    subject: 'any',
  },
]

export const _ = undefined
